import { Categories } from './categories';
import { OpenNow } from './open-now';
import { Tags } from './tags';

export const filterControls = {
  openNow: OpenNow,
  tags: Tags,
  categories: Categories
};
